import { keyBy, reduce, snakeCase } from "lodash"
import { theme } from "twin.macro"

export const BOOKING_STATUSES = [
    {
        key: 0,
        label: "Not Scheduled",
        color: theme`colors.text_error`,
        ttColor: theme`colors.red500`,
        bg: theme`colors.red200`
    },
    {
        key: 1,
        label: "Pending Upload",
        color: theme`colors.orange600`,
        bg: theme`colors.orange200`
    },
    {
        key: 2,
        label: "Uploaded",
        color: theme`colors.yellow800`,
        ttColor: theme`colors.yellow500`,
        bg: theme`colors.yellow200`
    },
    {
        key: 3,
        label: "Pending Approval",
        color: theme`colors.indigo600`,
        ttColor: theme`colors.indigo500`,
        bg: theme`colors.purple200`
    },
    {
        key: 9,
        label: "Submitting",
        color: theme`colors.orange600`,
        bg: theme`colors.orange200`
    },
    {
        key: 4,
        label: "Scheduling Confirmed",
        color: theme`colors.teal600`,
        ttColor: theme`colors.teal500`,
        bg: theme`colors.teal200`
    },
    {
        key: 5,
        label: "Blocked",
        color: theme`colors.gray600`,
        bg: theme`colors.gray200`
    },
    {
        key: 6,
        label: "Manually Scheduled",
        color: theme`colors.gray600`,
        bg: theme`colors.gray200`
    },
    {
        key: 7,
        label: "Cancellation Required",
        color: theme`colors.text_error`,
        bg: theme`colors.red200`
    },
    {
        key: 8,
        label: "Removed",
        color: theme`colors.gray600`,
        bg: theme`colors.gray200`
    },
    {
        key: 10,
        label: "Sub-Bookings",
        color: theme`colors.gray600`,
        bg: theme`colors.gray200`
    },
    {
        key: 88,
        label: "Pending",
        color: theme`colors.gray600`,
        bg: theme`colors.gray200`
    }
]

export const BOOKING_STATUS_MAP = keyBy(BOOKING_STATUSES, "key")
export const BOOKING_STATUS = reduce(
    BOOKING_STATUSES,
    (acc, crr) => ({ ...acc, [snakeCase(crr.label).toUpperCase()]: crr.key }),
    {}
)
